import {
  CloudUploadOutlined,
  CreditCardOutlined,
  DashboardOutlined,
  EditOutlined,
  MailOutlined,
  SettingOutlined,
  TruckOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons';

import { useCallback, useContext, useMemo } from 'react';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import AppShell from './AppShell';
import { UserContext } from '../context/UserProvider';
import { ParcelStatusContext } from '../context/ParcelStatusProvider';
import queryString from 'query-string';
import { parseSearchParam } from '../store/orderUtils';
import { notifyError } from '../store/utils';
import { API } from '../api';

const CustomerLayout = () => {
  const { user } = useContext(UserContext);
  const { statusList } = useContext(ParcelStatusContext);
  const navigate = useNavigate();
  const location = useLocation();

  const onSearch = useCallback((search: string) => {
    const params = parseSearchParam({ q: search });
    navigate(`/order/search?${queryString.stringify(params)}`);
  }, []);

  const logout = useCallback(async () => {
    try {
      await API.get({ apiVersion: 'api' })(`/auth/logout`);
      navigate('/');
    } catch (error: any) {
      notifyError(error.message);
    }
  }, []);

  const keys = useMemo(() => {
    const key = location.pathname
      .split('/')
      .filter((it: string) => it)
      .join('/');
    return [key];
  }, [location]);

  const openKeys = useMemo(() => {
    const keys = location.pathname.split('/').filter((it: string) => it);

    return keys;
  }, [location]);

  const items = useMemo(() => {
    const deliveryMenuItems = statusList.filter((status: any) => status.menu);
    return [
      {
        key: 'dashboard',
        icon: <DashboardOutlined />,
        label: <Link to="/dashboard">Хянах самбар</Link>,
      },
      {
        key: 'order',
        icon: <EditOutlined />,
        label: 'Дотоод захиалга',
        children: [
          {
            key: 'order/new',
            label: <Link to="/order/new">Захиалга бүртгэл</Link>,
            icon: <EditOutlined />,
          },
          {
            key: 'order/list',
            label: <Link to="/order/list">Захиалга жагсаалт</Link>,
            icon: <UnorderedListOutlined />,
          },
          {
            key: 'order/batch',
            label: <Link to="/order/batch">Файл бүртгэл</Link>,
            icon: <CloudUploadOutlined />,
          },
        ],
      },
      {
        key: 'delivery',
        label: 'Хүргэлт',
        icon: <TruckOutlined />,
        children: deliveryMenuItems.map((item: any) => {
          return {
            key: `delivery/${(item?.cd || '').toLowerCase()}`,
            label: <Link to={`/delivery/${(item?.cd || '').toLowerCase()}`}>{item?.name}</Link>,
          };
        }),
      },
      {
        key: 'report',
        label: 'Тайлан',
        icon: <SettingOutlined />,
        children: [
          {
            key: 'report/shipping',
            label: <Link to="/report/shipping">Хүргэлтийн нэгдсэн тайлан</Link>,
          },
        ],
      },
    ];
  }, [statusList]);

  // Not logged in: go straight to the login page without drawing the customer layout
  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  return (
    <AppShell
      user={user}
      items={items}
      keys={keys}
      openKeys={openKeys}
      onSearch={onSearch}
      onLogout={logout}
      logoPadding="17px 17px 17px 28px"
    />
  );
};
export default CustomerLayout;
